export const LOW_STOCK = 5;

export const stockOf = (p) => Math.max(0, Number(p?.stock ?? 0));

export const stockLabel = (stock) => {
  if (stock <= 0) return "Out of stock";
  if (stock <= LOW_STOCK) return `Only ${stock} left`;
  return "";
};
